import RegistrationDtoBuilder from "../../../../../common/helpers/registrationBuilder/RegistrationDtoBuilder";
import jwtUtils from "../../../../../common/utils/jwtUtils";
import { FormValues as INewBadge, ProductAttribute } from "../../../utils/types";
import EventHelper from "../../../../../common/network/helpers/event/EventHelper";
import PublicApiService from "../../../../../services/PublicApiService";
import { RegistrationDto } from "../../../../../common/helpers/registrationBuilder/types";
import { useSelector } from "react-redux";
import { badgeLocationSelector } from "../../../../../redux/eventEdition/selectors/eventEdition.selectors";
import { Preferences } from "../../CreateBadgeForm.types";
import { ReceiptOptions } from "@reedexpo/mercury-badge-manager-components";
import dayjs from "../../../../../common/dayjs";

type CreateRegistrationArgument = {
  visitorType: string;
  selectedProductSku: string;
  addonProductCodes?: string[];
  personInfo: INewBadge["personInfo"];
  badgeLocation: string;
  companyInfo: INewBadge["orgInfo"];
  eventEditionId: string;
  badgeNumber: string;
  orgId: string;
  attributes: ProductAttribute[];
  receiptOptions?: ReceiptOptions;
} & Partial<RegistrationDto>;

export const useCreateRegistration = () => {
  const badgeLocationUrl: string = useSelector(badgeLocationSelector)
  ;
  const createRegistration = async (data: CreateRegistrationArgument, correlationId: string, preferences: Preferences) => {
    const { id: eventId, gbsCode, primaryLocale } = EventHelper.eventEdition!;
    const { personInfo, companyInfo, visitorType, selectedProductSku, orgId, orderId, receiptOptions, supportStaffDetails } = data;
    const contactId = await jwtUtils.getContactIdFromToken();
    const payload = RegistrationDtoBuilder.setCreatedBy({ vendor: "Mercury", type: "rxAdmin", id: contactId })
      .setProducts([{ code: selectedProductSku, quantity: 1 }])
      .setPersonInfo(RegistrationDtoBuilder.getPersonInfoFromBadge(personInfo))
      .setOrganisationInfo(RegistrationDtoBuilder.transformOrgStateToDto(companyInfo))
      .getRegistrationPayload({
        atlasId: eventId,
        badgeLocationUrl,
        visitorType,
        gbsCode,
        locale: primaryLocale!,
        participatingOrganisationAtlasCode: orgId,
        orderId: orderId!,
        preferences,
        addonProductCodes: data.addonProductCodes?.map(code => code) || []
      });
    payload.badgeNumber = data.badgeNumber;

    if (supportStaffDetails) {
      payload.supportStaffDetails = supportStaffDetails;
    }
    if (data.paymentMethod) {
      payload.paymentMethod = data.paymentMethod;
    }

    if (receiptOptions) {
      payload.payments = [
        {
          paymentMethod: payload.paymentMethod ?? "",
          paymentReference: receiptOptions?.referenceNumber || receiptOptions?.authorisationCode || "",
          amount: receiptOptions.priceWithTax
        }
      ];
      payload.paymentDate = dayjs(new Date()).format();
    }

    if (data.cartId) {
      payload.cartId = data.cartId;
      if (!payload.paymentMethod) {
        payload.paymentMethod = "onsite_visa_master_other";
      }
    }

    return PublicApiService.createRegistration(payload, correlationId);
  };

  return { createRegistration };
};
